import { ENVIRONMENTS } from 'const';

export const isQaEnvironment = () => process.env.REACT_APP_ENV === ENVIRONMENTS.qa;
